import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "dweb-landing-page" */ './Desktop'));
